import { render, staticRenderFns } from "./pageList.vue?vue&type=template&id=23275a23&scoped=true&"
import script from "./pageList.vue?vue&type=script&lang=babel&"
export * from "./pageList.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23275a23",
  null
  
)

export default component.exports